import React from 'react';

// Components
import Subscription from './subscription';

// Utility functions
import { cartApi } from '~js/utils/cart-api';
import { getDisplayPrice } from '~js/utils/utils';
import { renderIcon } from '~js/utils/react-utils';

const LineItem = ({
  item,
  cartConfig,
  loading,
  setLoading,
  subsTooltip,
  setSubsTooltip,
  isNotSoloLast,
}) => {
  const isFreeGift = item.properties?._is_free_gift === 'true';

  return (
    <div className="border-p-cararra flex gap-3 border-b py-5 first:pt-6">
      {/* Item Image and Remove action */}
      <div className="w-20 flex-shrink-0">
        {item.image &&
          (isFreeGift ? (
            <>
              <img
                src={item.image}
                alt={item.title}
                className="h-auto w-full rounded-md"
              />
            </>
          ) : (
            <a href={item.url}>
              <img
                src={item.image}
                alt={item.title}
                className="h-auto w-full rounded-md"
              />
            </a>
          ))}

        {!isFreeGift && (
          <button
            onClick={() => cartApi.updateQty(item.key, 0, 'remove', setLoading)}
            className="mt-2 flex h-4 w-full justify-center text-xs text-p-darkTeal"
            disabled={loading?.status === true}
          >
            {loading?.itemKey === item.key && loading?.action === 'remove'
              ? renderIcon('loader')
              : 'Remove'}
          </button>
        )}
      </div>

      <div className="flex-1">
        {/* Item details & Price */}
        <div className="flex justify-between gap-6 lg:gap-8">
          {/* Item details */}
          <div>
            <h3 className="text-base font-semibold text-p-darkTeal lg:text-lg">
              {isFreeGift ? (
                <>{item.product_title}</>
              ) : (
                <a href={item.url}>{item.product_title}</a>
              )}
            </h3>
            {item.variant_title && (
              <p className="text-sm text-p-darkTeal">
                {item.variant_title.split(' / ').join(' | ')}
              </p>
            )}
            {isFreeGift && (
              <div className="flex items-center gap-1">
                {renderIcon('free-gift')}
                <span className="text-p-green text-xs font-semibold">
                  Free Gift
                </span>
              </div>
            )}
            {!isFreeGift && (
              <div className="mt-2 inline-flex items-center rounded-xl border border-dashed border-p-darkTeal text-sm text-p-darkTeal">
                <button
                  onClick={() =>
                    cartApi.updateQty(
                      item.key,
                      item.quantity - 1,
                      'decrease',
                      setLoading,
                    )
                  }
                  className="mx-2 w-3"
                  disabled={loading?.status === true}
                >
                  {loading?.itemKey === item.key &&
                  loading?.action === 'decrease'
                    ? renderIcon('loader')
                    : renderIcon('minus')}
                </button>
                <div className="mx-1 cursor-default text-center text-sm">
                  {item.quantity}
                </div>
                <button
                  onClick={() =>
                    cartApi.updateQty(
                      item.key,
                      item.quantity + 1,
                      'increase',
                      setLoading,
                    )
                  }
                  className="mx-2 w-3"
                  disabled={loading?.status === true}
                >
                  {loading?.itemKey === item.key &&
                  loading?.action === 'increase'
                    ? renderIcon('loader')
                    : renderIcon('plus')}
                </button>
              </div>
            )}
          </div>

          {/* Item Price */}
          <div className="text-right">
            {isFreeGift ? (
              <>
                <p
                  className={`text-sm font-semibold lg:text-base ${
                    item.price > item.final_price
                      ? 'text-p-red'
                      : 'text-p-darkTeal'
                  }`}
                >
                  {getDisplayPrice(item.final_price)}
                </p>
                {item.price > item.final_price && (
                  <p className="text-xs text-p-darkTeal line-through lg:text-sm">
                    {getDisplayPrice(item.price)}
                  </p>
                )}
              </>
            ) : (
              <>
                <p
                  className={`text-sm font-semibold lg:text-base ${
                    item.selling_plan_allocation?.compare_at_price >
                    item.final_price
                      ? 'text-p-red'
                      : 'text-p-darkTeal'
                  }`}
                >
                  {getDisplayPrice(item.final_price)}
                </p>
                {item.selling_plan_allocation?.compare_at_price >
                  item.final_price && (
                  <p className="text-xs text-p-darkTeal line-through lg:text-sm">
                    {getDisplayPrice(
                      item.selling_plan_allocation.compare_at_price,
                    )}
                  </p>
                )}
              </>
            )}
          </div>
        </div>
        {/* Subscribe & Save */}
        {/* <Subscription
          item={item}
          cartConfig={cartConfig}
          loading={loading}
          setLoading={setLoading}
          subsTooltip={subsTooltip}
          setSubsTooltip={setSubsTooltip}
          isNotSoloLast={isNotSoloLast}
        ></Subscription> */}
      </div>
    </div>
  );
};

export default LineItem;
